import { Component, OnInit } from '@angular/core';
import { FieldType, FieldWrapper, FormlyField, FormlyModule } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@Component({
    selector: 'app-select-genric-formly',
    templateUrl: './select-genric-formly.component.html',
    styleUrls: ['./select-genric-formly.component.scss'],
    imports: [NgSelectComponent, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule, FormlyModule]
})
export class SelectGenricFormlyComponent extends FieldType implements OnInit {
  isStringArray = false;
  incomingMultipleValue = false;

  get labelProp(): string { return this.to.labelProp || 'label'; }
  get valueProp(): string { return this.to.valueProp || 'value'; }
  get groupProp(): string { return this.to.groupProp || 'group'; }

  ngOnInit() {
    console.log("model is ", this.model)
    console.log("options are ", this.to)
    if(this.formControl)
      console.log("formcontrol is ", this.formControl.value)
    console.log("field is ", this.field)
    this.incomingMultipleValue = this.to.multiple;
    if(this.to && this.to.allowAdding && this.formControl && Array.isArray(this.formControl.value) && Array.isArray(this.to.options)){
      let additionalOptions = (this.formControl.value).map(item => ({ value: item, label: item }));
      this.to.options = [...additionalOptions];
    }
  }

  onModelChange(value: any): void {
    console.log("model is ", this.model)
    console.log("options are ", this.to)
    // if(this.model && this.model.operator && (this.model.operator == 'startsWith') || (this.model.operator == 'contains') || (this.model.operator == 'notContains')){
    //   setTimeout(() => this.incomingMultipleValue = false)  
    //   // if(this.model.value && Array.isArray(this.model.value)){
    //   //   setTimeout(() => this.model.value = null)
    //   //   this.formControl.setValue(null)
    //   //   this.formControl.updateValueAndValidity()
    //   // }
    // }
    // else
    //   setTimeout(() => this.to.multiple = this.incomingMultipleValue)  
    
  }

  addTag(tag: string) {
    if(this.to.allowAdding){
      return {value : tag, label : tag};
    }
    else
      return
  }

  onTagAdded(ev){
    console.log("Tag Added Event received ", ev);
    console.log("model is ", this.model)
    console.log("options are ", this.to)
    console.log("formcontrol is ", this.formControl.value)
    if(this.to && this.to.allowAdding && this.formControl && Array.isArray(this.to.options)){
      let additionalOptions = (this.formControl.value).map(item => ({ value: item, label: item }));
      this.to.options = [...additionalOptions];
    }
  }

  // ngOnInit() {
  //   this.selectOptions$ = this.selectOptions as Observable<any[]>;

  //   // Set the initial selected value from the model
  //   const selectedValue = this.model[this.key];
  //   if (selectedValue) {
  //     this.formControl.setValue(selectedValue);
  //   }
  // }

}
